import { Injectable } from "@angular/core";
import { AssetListService } from "@modules/trade/services/asset-list.service";
import { Tradable } from "@models/interfaces/tradable";
import { AssetsTradeScrollService } from "@main-services/assets-trade-scroll.service";
import { LeveragedToken } from "@models/asset/cryptocoins/currencies/leveraged_tokens";
import { TOKEN_BEST_ID } from "@helpers/constants";

@Injectable()
export class SavingsPlanAssetListService extends AssetListService {
	constructor(public assetTradeScrollService: AssetsTradeScrollService) {
		super(assetTradeScrollService);
	}

	public filterList(list: Tradable[]): Tradable[] {
		return list.filter(
			(tradable) =>
				tradable.isBuyActive() && !(tradable instanceof LeveragedToken) && tradable.getId() !== TOKEN_BEST_ID
		);
	}
}
